(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["password-orchestrator"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-po-root]').forEach(initOrchestrator);

    function initOrchestrator(root) {
      if (root.dataset.poInitialized) return;
      root.dataset.poInitialized = 'true';

      const container = root.closest('.section-content-wrapper');
      if (!container) return;

      if (container.querySelector('.po-stack')) return;

      const groups = Array.from(container.children).filter((el) =>
        el.classList.contains('group-block')
      );
      if (groups.length < 3) return;

      const contentGroup = groups.find((g) => g.querySelector('.email-signup-block'));
      if (!contentGroup) return;

      const others = groups.filter((g) => g !== contentGroup);
      if (others.length < 2) return;

      const contentIdx = groups.indexOf(contentGroup);
      const introGroup = others.find((g) => groups.indexOf(g) < contentIdx) || others[0];
      const dateGroup =
        others.find((g) => groups.indexOf(g) > contentIdx) || others[others.length - 1];
      if (!introGroup || !dateGroup || introGroup === dateGroup) return;

      const stack = document.createElement('div');
      stack.className = 'po-stack';
      introGroup.before(stack);
      stack.appendChild(introGroup);
      stack.appendChild(contentGroup);
      stack.appendChild(dateGroup);

      introGroup.classList.add('po-layer', 'po-layer--visible');
      contentGroup.classList.add('po-layer');
      dateGroup.classList.add('po-layer');

      const introDuration = (parseFloat(root.dataset.introDuration) || 4) * 1000;
      const successDuration = (parseFloat(root.dataset.successDuration) || 4) * 1000;

      const justSubscribed = !!contentGroup.querySelector('.email-signup__message-text');

      function showContent() {
        introGroup.classList.remove('po-layer--visible');
        contentGroup.classList.add('po-layer--visible');
      }

      function showDate() {
        contentGroup.classList.remove('po-layer--visible');
        dateGroup.classList.add('po-layer--visible');
      }

      if (justSubscribed) {
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', window.location.pathname);
        }
        showContent();
        setTimeout(showDate, successDuration);
        return;
      }

      setTimeout(showContent, introDuration);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
